<template>
  <base-modal height="600"
              :show="show"
              @close="close">
    <social-media-header slot="header" />

    <social-media :child-id="fromBus.childId" />
  </base-modal>
</template>

<script>
  import SocialMedia from '@/components/Child/ChildSocialMedia/SocialMedia'
  import SocialMediaHeader from '@/components/Child/ChildSocialMedia/SocialMediaHeader'  
  import modalMixin from '@/mixins/modalMixin'

  export default {
    mixins: [
      modalMixin
    ],

    components: {
      SocialMedia,
      SocialMediaHeader
    },

    data() {
      return {
        fromBus: {
          childId: ''
        }
      }
    },

    beforeMount() {
      this.setOpenListener('socialMedia')
    }
  }
</script>
